import { ConvertToBase64String } from "@/util/Image";
import { useGetUserSignatures, useSaveUserSignature } from "@/queries/user.queries";

export function SettingsPage() {
  const signatures = useGetUserSignatures();
  const saveSignatures = useSaveUserSignature();

  async function selectSignature(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.files) {
      const base64 = await ConvertToBase64String(e.target.files[0]);
      setSignature(base64);
    }
  }

  function setSignature(image: string) {
    if (signatures.data) {
      const signature = { ...signatures.data[0], signature: image };
      saveSignatures.mutate(signature);
    }
  }

  return (
    <>
      <h3>Settings</h3>
      <div className="mt-3">
        <div className="d-flex flex-row">
          <div className="d-flex flex-column">
            Signature
            <img
              src={signatures.data && signatures.data.length > 0 ? signatures.data[0].signature : ""}
              width="150"
              height="50"
              className="user-signature me-3"
            />
            <span>
              <label role="button" htmlFor="select1" className="link-secondary small me-1">
                Select
              </label>
              <input type="file" id="select1" className="d-none" onChange={selectSignature} />|
              <a role="button" className="link-secondary small ms-1" onClick={() => setSignature("")}>
                Clear
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
